export default __webpack_public_path__ + "static/media/contributorsActive.55c03de1.svg";